import { Link } from 'react-router-dom';
import GableMark from './GableMark';
import './ui.css';

/**
 * Interior page banner.
 *
 * Every page below Home renders exactly one <h1> here — the previous site had
 * no h1 on any interior page (WCAG 1.3.1 / 2.4.6).
 *
 * When `image` is supplied a fixed navy gradient sits over it, so heading
 * contrast does not depend on the photograph.
 */
const PageHero = ({ eyebrow, title, lead, image, breadcrumbs = [], children }) => (
  <section
    className={`page-hero on-navy${image ? ' page-hero--image' : ''}`}
  >
    {image && (
      <div
        className="page-hero__bg"
        style={{ backgroundImage: `url(${image})` }}
        role="presentation"
      />
    )}
    <GableMark className="page-hero__motif" />

    <div className="container">
      {breadcrumbs.length > 0 && (
        <nav className="breadcrumb" aria-label="Breadcrumb">
          <ol>
            {breadcrumbs.map((crumb, i) => {
              const isLast = i === breadcrumbs.length - 1;
              return (
                <li key={crumb.to || crumb.label}>
                  {isLast || !crumb.to ? (
                    <span aria-current="page">{crumb.label}</span>
                  ) : (
                    <Link to={crumb.to}>{crumb.label}</Link>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      )}

      <div className="page-hero__inner">
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1 className="page-hero__title">{title}</h1>
        {lead && <p className="page-hero__lead">{lead}</p>}
        {children}
      </div>
    </div>
  </section>
);

export default PageHero;
